module.exports = __webpack_public_path__ + "static/img/zoom_btn3.08c50d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/zoom_btn3.png
// module id = xyZ6
// module chunks = 4